import { createContext, use } from "react";

export const ChipPopupContext = createContext<{ close: () => void }>({
  close: () => {},
});

export const useChipPopup = () => use(ChipPopupContext);
